/* global femcare */

femcare.form.fileUpload = {
    uploadedFiles: [],
    uploadInput: null,
    uploadButton: null,
    uploadStatus: null,

    /**
     * Initializes the file upload functionality.
     * Sets up the file uploader for each '.file-uploader' container found.
     */
    init: function () {
        $('.file-uploader').each((index, element) => {
            const uploaderContainer = $(element);
            this.setupEventListeners(uploaderContainer);
        });
    },

    /**
     * Sets up the necessary event listeners for a specific uploader container.
     * @param {jQuery} uploaderContainer - The jQuery element representing the uploader container.
     */
    setupEventListeners: function (uploaderContainer) {
        const uploadInput = uploaderContainer.find('.upload');
        const uploadButton = uploaderContainer.find('.upload__button');
        const uploadStatus = uploaderContainer.find('.upload__status');
        const uploadEntries = uploaderContainer.find('.upload__entries');
        const uploadReset = uploaderContainer.find('.upload__reset');

        uploadButton.on('click', () => {
            uploadInput.click(); // Simulate file input click
            uploadEntries.empty();
        });

        uploadInput.on('change', (event) => {
            this.handleFilesSelected(event.target.files, uploadEntries, uploadInput, uploadStatus);
        });

        uploadReset.on('click', () => {
            uploadInput.val('');
            this.uploadedFiles = [];
            uploadEntries.empty();
            this.updateUploadStatus(uploadStatus);
            if (uploadInput.validate) {uploadInput.validate();}
        });
    },

    /**
     * Handles the selected files, updates the UI based on these files, and updates the internal state.
     * @param {FileList} files - The files selected by the user.
     * @param {jQuery} uploadEntries - The jQuery element where file entries are displayed.
     * @param {jQuery} uploadInput - The jQuery element for the file input.
     * @param {jQuery} uploadStatus - The jQuery element for displaying the upload status.
     */
    handleFilesSelected: function (files, uploadEntries, uploadInput, uploadStatus) {
        this.uploadedFiles = Array.from(files);
        this.updateUploadEntries(uploadEntries, uploadInput);
        this.updateUploadStatus(uploadStatus);
        if (uploadInput.validate) {
            uploadInput.validate();
        }
    },

    /**
     * Updates the list of files displayed to the user in the UI.
     * @param {jQuery} uploadEntries - The jQuery element where file entries are displayed.
     * @param {jQuery} uploadInput - The jQuery element for the file input.
     */
    updateUploadEntries: function (uploadEntries, uploadInput) {
        const formGroup = uploadInput.closest('.form-group');
        if (!formGroup.hasClass('has-error')) {
            uploadEntries.empty();

            this.uploadedFiles.forEach((file) => {
                const fileEntry = $(`
                    <div class="upload__entry">
                        <div class="upload__progress"></div>
                        <div class="upload__details">
                            <span class="upload__file-name">${file.name}</span>
                            <i class="icon-validation-success"></i>
                        </div>
                    </div>
                `);
                uploadEntries.append(fileEntry);
            });
        }
    },

    /**
     * Updates the upload status label based on the number of files currently uploaded.
     * @param {jQuery} uploadStatus - The jQuery element for displaying the upload status.
     */
    updateUploadStatus: function (uploadStatus) {
        if (this.uploadedFiles.length > 0) {
            uploadStatus.text(`${uploadStatus.data('text-uploaded')} ${this.uploadedFiles.length}`);
            uploadStatus.siblings('.upload__reset').removeClass('hidden');
        } else {
            uploadStatus.text(uploadStatus.data('text-default'));
            uploadStatus.siblings('.upload__reset').addClass('hidden');
        }
    }
};
